import React from "react";

const Logo = () => {
  const redirectHome = () => {
    window.location.href = "/";
  };
  return (
    <div className="logo-container" onClick={redirectHome}>
      <img className="logo-img" src="/assets/logo.png" alt="Logo" />
    </div>
  );
};

export default Logo;